import BatchActionsBar from './BatchActionsBar'

export default BatchActionsBar
